import { render, staticRenderFns } from "./personal-info.vue?vue&type=template&id=5da655a0&scoped=true&"
import script from "./personal-info.vue?vue&type=script&lang=js&"
export * from "./personal-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-info.vue?vue&type=style&index=0&id=5da655a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da655a0",
  null
  
)

export default component.exports